<section class="countdown" *ngIf="mode === 'sale'" aria-label="Countdown to the DVLA sale">
  <div class="wrap">
    <div class="countdown-text">
      <span class="eyebrow">DVLA sale</span>
      <p class="countdown-when" *ngIf="!open">The {{ year }} plates go on sale at {{ label }}.</p>
      <p class="countdown-when" *ngIf="open">The {{ year }} plates are on sale now at DVLA.</p>
    </div>
    <ng-container *ngTemplateOutlet="clock"></ng-container>
  </div>
</section>

<div class="countdown-list" *ngIf="mode === 'list'" aria-label="Countdown to your list">
  <span class="eyebrow eyebrow--list" *ngIf="!open">Opens in</span>
  <span class="countdown-list-open" *ngIf="open">Your list is open. Refresh the page to see it.</span>
  <ng-container *ngTemplateOutlet="clock"></ng-container>
</div>

<ng-template #clock>
  <div class="countdown-clock" *ngIf="!open" role="timer" aria-live="off">
    <div class="unit"><span class="num">{{ days }}</span><span class="cap">{{ days === 1 ? 'day' : 'days' }}</span></div>
    <div class="unit"><span class="num">{{ pad(hours) }}</span><span class="cap">hrs</span></div>
    <div class="unit"><span class="num">{{ pad(minutes) }}</span><span class="cap">mins</span></div>
    <div class="unit"><span class="num">{{ pad(seconds) }}</span><span class="cap">secs</span></div>
  </div>
</ng-template>
